export const RESET_USERS = "RESET_USERS";
export const RESET_USER = "RESET_USER";
export const RESET_ERROR = "RESET_ERROR";

export const GET_USERS = "GET_USERS";
export const SET_USERS = "SET_USERS";

export const API_ERROR = "USERS_API_ERROR";

export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";

export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";

export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";

export const ACTIVATE_USER = "ACTIVATE_USER";
export const ACTIVATE_USER_SUCCESS = "ACTIVATE_USER_SUCCESS";

export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD";
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS";




